export default "__VITE_ASSET__7be7b261__"